<header class="topbar">
  <app-time-check></app-time-check>
  <nav class="d-flex top-navbar navbar-expand-md navbar-light">
    <!-- ============================================================== -->
    <!-- Logo -->
    <!-- ============================================================== -->
    <div class="navbar-header d-none d-xl-block">
      <a class="navbar-brand" [routerLink]="currentUser?.homePage">
        <b>
          <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo" />
          <img src="assets/images/logo-light-icon.png" alt="homepage" class="light-logo" />
        </b>
        <span>
          <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo" />
          <img src="assets/images/logo-light-text.png" class="light-logo" alt="homepage" />
        </span>
      </a>
    </div>
    <!-- ============================================================== -->
    <!-- End Logo -->
    <!-- ============================================================== -->
    <div class="navbar-collapse">
      <!-- ============================================================== -->
      <!-- toggle and nav items -->
      <!-- ============================================================== -->
      <ul class="navbar-nav mr-auto mt-md-0 text-center">
        <!-- This is  -->
        <li (click)="toggleSidebar.emit()" class="nav-item m-l-10 hidden-xxl-down">
          <a class="nav-link sidebartoggler waves-effect waves-dark" href="javascript:void(0)">
            <i class="fas fa-bars  fa-2x"></i></a>
        </li>

        <li class="nav-item search-box " placement="bottom-right">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" routerLink="/pages/home-menu">
            <!-- <i class="fas fa-home"></i> -->
            {{'menuitem.home-menu' | translate}}
          </a>

        </li>

        <li class="nav-item hidden-sm-down search-box " placement="bottom-right" *ngxPermissionsOnly="[roleCodeEnum.MENU_CUSTOMER_SEARCH]">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" routerLink="/pages/customer-search">
            <!-- <i class="fas fa-search"></i> -->
            {{'menuitem.customer-search' | translate}}
          </a>
        </li>
        <li class="nav-item hidden-lg-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_DASHBOARD]">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" routerLink="/pages/dashboard" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.dashboard'| translate">
            <i class="fas fa-tachometer-alt fa-2x text-white"></i>
          </a>
        </li>
        <li class="nav-item hidden-sm-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_QUICK_ORDER]">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" routerLink="/pages/quick-order" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.quick-order'| translate">
            <i class="fas fa-bolt fa-2x"></i>
          </a>
        </li>


        <li class="nav-item hidden-sm-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_ORDER_SEARCH]">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" routerLink="/pages/search-order" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.search-order'| translate">
            <i class="fas fa-search fa-2x"></i>
          </a>
        </li>

        <li class="nav-item hidden-sm-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_ORDER_LIST]">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" routerLink="/pages/order-list" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.order-list'| translate">
            <i class="fas fa-shopping-cart fa-2x"></i>
          </a>
        </li>

        <li class="nav-item hidden-md-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_CASH_REPORT]">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" routerLink="/pages/cash-report" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.cash-report'| translate">
            <i class="fas fa-file-alt fa-2x"></i>
          </a>
        </li>


        <li class="nav-item hidden-md-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_DEVICE]">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="openDeviceSettingModal()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.device-settings'| translate">
            <i class="fas fa-cog fa-2x "></i>
          </a>
        </li>
        <li class="nav-item  hidden-sm-down">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="openPrinterSetting()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.printer-settings'| translate">
            <i class="fas fa-print fa-2x "></i>
          </a>
        </li>
        <li class="nav-item hidden-lg-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_CALLERID_HISTORY_REPORT]">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="openCalleridHistoryReportModal()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.callerid-history-report'| translate">
            <i class="fas fa-phone fa-2x"></i>
          </a>
        </li>
        <li class="nav-item hidden-lg-down" *ngxPermissionsOnly="[roleCodeEnum.MENU_SMS_LOG_REPORT]">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="openSmsLogReportModal()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.sms-log-report'| translate">
            <i class="fas fa-sms fa-2x"></i>
          </a>
        </li>
        <li class="nav-item  hidden-xxl-down">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="openHelpVideoModal()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'menuitem.help-video'| translate">
            <i class="fas fa-question-circle fa-2x "></i>
          </a>
        </li>

        <!-- Favori Menüler -->
        <li class="nav-item hidden-sm-down favorites-nav-item" (click)="toggleFavoritesPopover()">
          <div class="nav-link text-muted waves-effect waves-dark" triggers="manual" placement="auto" container="body" #favoritesPopover="ngbPopover" [ngbPopover]="favoritesPopoverContent"
            popoverClass="favorites-popover-dropdown">
            <i class="fas fa-star fa-2x text-warning"></i>
          </div>
        </li>

        <!-- <li class="nav-item" *ngIf="deviceLocalStorageData?.isOpenCashRegisterAfterPrintReceipt">
          <a class="nav-link hidden-sm-down text-muted waves-effect waves-dark" (click)="openCashDrawer()" triggers="mouseenter:mouseleave" placement="auto" container="body"  [ngbPopover]="'button.open-cash-drawer'| translate">

            <i class="fas fa-money-bill  fa-2x"></i>
          </a>
        </li> -->



        <!-- ============================================================== -->
        <!-- Comment -->
        <!-- ============================================================== -->
        <li class="nav-item reminder-nav-item" (click)="toggleReminderPopover()">
          <div class="nav-link text-muted waves-effect waves-dark" triggers="manual" placement="auto" container="body" #reminderPopover="ngbPopover" [ngbPopover]="reminderPopoverContent"
            popoverClass="reminder-popover-dropdown">
            <i class="fas fa-bell fa-2x text-white"></i>
            <span class="badge badge-danger notification-badge">{{ reminderOperationalService.reminders?.length }}</span>
          </div>
        </li>


        <li class="nav-item">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="goBack()" triggers="mouseenter:mouseleave" placement="auto" container="body" [ngbPopover]="'button.back'| translate">
            <i class="fas fa-arrow-left  fa-2x"></i>
            <!-- {{'button.back' | translate}} -->
          </a>
        </li>

        <!-- ============================================================== -->
        <!-- End Comment -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Messages -->
        <!-- ============================================================== -->
        <!-- <li class="nav-item dropdown" ngbDropdown placement="bottom-left">
          <a ngbDropdownToggle class="nav-link text-muted waves-effect waves-dark" href="javascript:void(0)">
            <i class="mdi mdi-email"></i>
            <div class="notify">
              <span class="heartbit"></span>
              <span class="point"></span>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-left mailbox" ngbDropdownMenu>
            <ul>
              <li>
                <div class="drop-title">You have 4 new messages</div>
              </li>
              <li>
                <div class="message-center" [perfectScrollbar]="config">
                  <a href="#" *ngFor="let mymessage of mymessages">
                    <div class="user-img">
                      <img src="{{ mymessage.useravatar }}" alt="user" class="img-circle" width="40" />
                      <span class="profile-status {{ mymessage.status }} pull-right"></span>
                    </div>
                    <div class="mail-contnet">
                      <h5>{{ mymessage.from }}</h5>
                      <span class="mail-desc">{{ mymessage.subject }}</span>
                      <span class="time">{{ mymessage.time }}</span>
                    </div>
                  </a>
                </div>
              </li>
              <li>
                <a class="nav-link text-center" href="javascript:void(0);">
                  <strong>See all e-Mails</strong>
                  <i class="fas fa-angle-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </li> -->
        <!-- ============================================================== -->
        <!-- End Messages -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Messages -->
        <!-- ============================================================== -->
        <!-- <li class="nav-item dropdown mega-dropdown" ngbDropdown [autoClose]="false">
          <a ngbDropdownToggle class="nav-link text-muted waves-effect waves-dark" href="javascript:void(0)">
            <i class="mdi mdi-view-grid"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
            <ul class="mega-dropdown-menu row">
              <li class="col-lg-3 col-xlg-2 m-b-30">
                <h4 class="m-b-20">CAROUSEL</h4>
                <ngb-carousel>
                  <ng-template ngbSlide>
                    <img src="assets/images/big/img1.jpg" class="img-responsive" alt="Random first slide" />
                    <div class="carousel-caption">
                      <h3 class="text-white font-bold">First slide label</h3>
                    </div>
                  </ng-template>
                  <ng-template ngbSlide>
                    <img src="assets/images/big/img2.jpg" class="img-responsive" alt="Random second slide" />
                    <div class="carousel-caption">
                      <h3 class="text-white font-bold">Second slide label</h3>
                    </div>
                  </ng-template>
                  <ng-template ngbSlide>
                    <img src="assets/images/big/img3.jpg" class="img-responsive" alt="Random third slide" />
                    <div class="carousel-caption">
                      <h3 class="text-white font-bold">Third slide label</h3>
                    </div>
                  </ng-template>
                </ngb-carousel>
              </li>
              <li class="col-lg-3 m-b-30">
                <h4 class="m-b-20">ACCORDION</h4>
                <ngb-accordion #acc="ngbAccordion" activeIds="ngb-panel-0" class="accordion nav-accordion">
                  <ngb-panel title="Simple">
                    <ng-template ngbPanelContent>
                      Anim pariatur cliche reprehenderit, enim eiusmod high life
                      accusamus terry richardson ad squid.
                    </ng-template>
                  </ngb-panel>
                  <ngb-panel>
                    <ng-template ngbPanelTitle>
                      <span>&#9733; <b>Fancy</b> title &#9733;</span>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      Anim pariatur cliche reprehenderit, enim eiusmod high life
                      accusamus terry richardson ad squid.
                    </ng-template>
                  </ngb-panel>
                  <ngb-panel title="Disabled" [disabled]="true">
                    <ng-template ngbPanelContent>
                      Anim pariatur cliche reprehenderit, enim eiusmod high life
                      accusamus terry richardson ad squid.
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </li>

              <li class="col-lg-3 m-b-30">
                <h4 class="m-b-20">CONTACT US</h4>
                <form>
                  <div class="form-group">
                    <input type="text" class="form-control" id="exampleInputname1" placeholder="Enter Name" />
                  </div>
                  <div class="form-group">
                    <input type="email" class="form-control" placeholder="Enter email" />
                  </div>
                  <div class="form-group">
                    <textarea class="form-control" id="exampleTextarea" rows="3" placeholder="Message"></textarea>
                  </div>
                  <button type="submit" class="btn btn-info">Submit</button>
                </form>
              </li>
              <li class="col-lg-3 col-xlg-4 m-b-30">
                <h4 class="m-b-20">List style</h4>
                <ul class="list-style-none">
                  <li>
                    <a href="javascript:void(0)">
                      <i class="fas fa-check text-success"></i> You can give
                      link</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="fas fa-check text-success"></i> Give link</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="fas fa-check text-success"></i> Another Give
                      link</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="fas fa-check text-success"></i> Forth link</a>
                  </li>
                  <li>
                    <a href="javascript:void(0)">
                      <i class="fas fa-check text-success"></i> Another fifth
                      link</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </li> -->





        <!-- ============================================================== -->
        <!-- End Messages -->
        <!-- ============================================================== -->
      </ul>


      <div class="spacer"></div>
      <!-- ============================================================== -->
      <!-- User profile and search -->
      <!-- ============================================================== -->
      <ul class="navbar-nav my-lg-0">
        <li class="nav-item hidden-sm-down">
          <a class="nav-link text-white border border-danger rounded px-3 py-1 waves-effect waves-dark" (click)="downloadService.downloadSupportApp()" triggers="mouseenter:mouseleave" placement="auto"
            container="body" [ngbPopover]="'link.download-support-app'| translate">
            {{'button.get-support'| translate}}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="reloadApp()" triggers="mouseenter:mouseleave" placement="auto" container="body" [ngbPopover]="'button.update-app'| translate">
            v{{version}}
          </a>
        </li>
      </ul>

      <ul class="navbar-nav my-lg-0 hidden-sm-down" *ngIf="currentUser">
        <li class="nav-item">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="openPin()" title="{{currentUser.screenName}}">
            <i class="fas fa-user"></i>
            {{currentUser.screenName | slice:0:10}}{{currentUser.screenName.length > 10 ? '...' : ''}}
          </a>
        </li>

      </ul>

      <app-clock-widget *ngIf="deviceLocalStorageData?.showClockOnHeader"></app-clock-widget>


      <ul class="navbar-nav my-lg-0 ">


        <li class="nav-item  hidden-lg-down" *ngIf="currentUser?.deviceType==deviceTypeEnum.WEB">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="lockScreen()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'button.lock-screen'| translate">
            <i class="fas fa-lock  fa-2x"></i>
            <!-- {{'button.change-screen-mode' | translate}} -->
          </a>
        </li>

        <li class="nav-item" *ngIf="currentUser?.deviceType==deviceTypeEnum.WEB">
          <a class="nav-link text-muted waves-effect waves-dark" (click)="changeScreenSize()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'button.change-screen-mode'| translate">
            <i class="fas fa-expand  fa-2x"></i>
            <!-- {{'button.change-screen-mode' | translate}} -->
          </a>
        </li>

        <li class="nav-item hidden-sm-down">
          <a class="nav-link text-muted waves-effect waves-dark " [skipLocationChange]="false" (click)="logout()" triggers="mouseenter:mouseleave" placement="auto" container="body"
            [ngbPopover]="'authentication.logout'| translate">
            <i class="fas fa-sign-out-alt  fa-2x text-danger"></i>
            <!-- {{'authentication.logout' | translate}} -->
          </a>
        </li>



        <!-- ============================================================== -->
        <!-- Profile -->
        <!-- ============================================================== -->
        <!-- <li class="nav-item dropdown" ngbDropdown placement="bottom-right" *ngIf="currentUser">
          <a ngbDropdownToggle class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img [src]="currentUser.avatarUrl" alt="user" class="profile-pic" />
          </a>
          <div class="dropdown-menu dropdown-menu-left" ngbDropdownMenu>
            <ul class="dropdown-user">
              <li>
                <div class="dw-user-box" *ngIf="currentUser">
                  <div class="u-img">
                    <img [src]="currentUser.avatarUrl" alt="user" />
                  </div>
                  <div class="u-text">
                    <h4>{{currentUser.screenName}}</h4>
                    <h5>{{currentUser.storeName}}</h5>
                    <p class="text-muted">{{currentUser.userName}}</p>
                  </div>
                </div>
              </li>

              <li class="nav-item">
                <a (click)="checkPrinterStatus()">
                  <i class="fas fa-print"></i>
                  {{'button.check-printer-status' | translate}}
                </a>
              </li>

              <li class="nav-item" *ngxPermissionsOnly="[roleCodeEnum.MENU_DEVICE]">
                <a [skipLocationChange]="false" routerLink="/pages/device-setting">
                  <i class="fas fa-cog"></i>
                  {{'menuitem.device-settings' | translate}}
                </a>
              </li>

              <li class="nav-item" *ngIf="currentUser.deviceType==deviceTypeEnum.WEB">
                <a href="https://aktifmusteri.com/download/setup/destek_al.exe">
                  <i class="fas fa-download"></i>
                  {{'link.download-support-app' | translate}}
                </a>
              </li>

              <li class="nav-item" *ngIf="currentUser.deviceType==deviceTypeEnum.WEB">
                <a href="https://aktifmusteri.com/download/setup/aktifmusteri.exe">
                  <i class="fas fa-download"></i>
                  {{'link.download-windows-app' | translate}}
                </a>
              </li>


              <li class="nav-item" *ngIf="currentUser.deviceType==deviceTypeEnum.WEB">
                <a href="https://aktifmusteri.com/download/setup/JavaSetup8.exe">
                  <i class="fas fa-download"></i>
                  {{'link.download-java' | translate}}
                </a>
              </li>



              <li role="separator" class="divider"></li>
              <li>
                <a (click)="logout()">
                  <i class="fas fa-power-off"></i> Çıkış</a>
              </li>
            </ul>
          </div>
        </li> -->



        <li class="nav-item" *ngIf="currentUser">
          <a class="nav-link text-muted waves-effect waves-dark" [skipLocationChange]="false" (click)="openUserProfile(userProfileContent)" triggers="mouseenter:mouseleave" placement="auto"
            container="body" [ngbPopover]="'title.login-user-detail'| translate">
            <i class="fas fa-user text-o fa-2x"></i>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</header>


<ng-template #userProfileContent let-offcanvas>
  <div class="offcanvas-header">
    <h5 class="card-title">
      <i class="fas fa-user-circle me-2"></i>
      {{ 'title.login-user-detail' | translate }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body">
    <div class="card user-details-card">
      <div *ngIf="currentUser" class="card-body user-info">
        <div class="user-text">
          <h4><i class="fas fa-crown me-2"></i>{{ currentUser.screenName }}</h4>
          <h5><i class="fas fa-building me-2"></i>{{ currentUser.storeName }}</h5>
          <p><i class="fas fa-envelope me-2"></i>{{ currentUser.userName }}</p>
        </div>
      </div>
      <div class="card-footer links">
        <div class="nav-item" *ngxPermissionsOnly="[roleCodeEnum.MENU_DEVICE]">
          <a [skipLocationChange]="false" routerLink="/pages/device-setting">
            <i class="fas fa-cogs"></i> {{ 'menuitem.device-settings' | translate }}
          </a>
        </div>
        <div class="nav-item">
          <a (click)="openCashRegisterQuickAccess()">
            <i class="fas fa-cash-register"></i> {{'title.cash-register-quick-access' | translate}}
          </a>
        </div>
        <!-- <div *ngIf="currentUser.deviceType==deviceTypeEnum.WEB" class="nav-item">
          <a (click)="downloadService.downloadSupportApp()">
            <i class="fas fa-headset"></i> {{ 'link.download-support-app' | translate }}
          </a>
        </div> -->
        <div class="nav-item">
          <a [skipLocationChange]="false" routerLink="/pages/owner-sales-product">
            <i class="fas fa-chart-line"></i> {{ 'menuitem.owner-sales-product' | translate }}
          </a>
        </div>
        <div class="nav-item">
          <a [skipLocationChange]="false" routerLink="/pages/software-tools">
            <i class="fas fa-tools"></i> {{ 'menuitem.software-tools' | translate }}
          </a>
        </div>

        <div class="nav-item">
          <a (click)="checkPrinterStatus()">
            <i class="fas fa-print"></i> {{'button.check-printer-status' | translate}}
          </a>
        </div>
        <div class="nav-item">
          <a (click)="saveUserSessionStorage()">
            <i class="fas fa-save"></i> {{'button.save-user-session-settings' | translate}}
          </a>
        </div>
        <div class="nav-item">
          <a (click)="openCustomerScreen()">
            <i class="fas fa-desktop"></i> {{'menuitem.customer-screen' | translate}}
          </a>
        </div>
        <div class="nav-item">
          <a (click)="openHelpVideoModal()">
            <i class="fas fa-question-circle"></i> {{'menuitem.help-video' | translate}}
          </a>
        </div>
        <div class="nav-item logout-item">
          <a (click)="logout()">
            <i class="fas fa-sign-out-alt"></i> {{'authentication.logout' | translate}}
          </a>
        </div>

        <!-- Version Bilgileri - Kompakt -->
        <div class="version-section">
          <div class="version-item">
            <a class="version-link" (click)="reloadApp()" triggers="mouseenter:mouseleave" placement="auto" container="body" [ngbPopover]="'button.update-app'| translate">
              <i class="fas fa-sync-alt"></i>v{{version}}
            </a>
          </div>
          <div class="version-item" *ngIf="localAppVersion">
            <a class="version-link" (click)="downloadAktifMusteri()" triggers="mouseenter:mouseleave" placement="auto" container="body" [ngbPopover]="'link.download-windows-app'| translate">
              <i class="fas fa-server"></i>v{{localAppVersion.version}}
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>
</ng-template>

<!-- Hatırlatıcılar Popover Content -->
<ng-template #reminderPopoverContent>
  <div class="reminder-popover">
    <div class="drop-title">Hatırlatıcılar</div>
    <div class="message-center" [perfectScrollbar]="config" style="max-height: 300px;">
      <a (click)="openReminderModal(notification); closeReminderPopover()" *ngFor="let notification of reminderOperationalService.reminders" class="d-block p-2 border-bottom reminder-item"
        href="javascript:void(0)">
        <div class="d-flex align-items-start">
          <div class="round me-2" [ngClass]="getNotificationClass(notification.notificationDate)">
            <i class="fas fa-2x {{ getNotificationIconClass(notification.type) }}"></i>
          </div>
          <div class="mail-contnet flex-grow-1">
            <h5 class="mb-1">{{ notification.title }}</h5>
            <span class="mail-desc d-block">{{ notification.message }}</span>
            <span class="time small text-muted">{{ notification.remindDate | date: dateFormatEnum.DATE_TIME_FORMAT_DISPLAY }}</span>
            <span class="notification-date small text-muted d-block">{{ notification.notificationDate | date: dateFormatEnum.DATE_TIME_FORMAT_DISPLAY }}</span>
          </div>
        </div>
      </a>
    </div>
    <a class="nav-link text-center py-2 d-block border-top" [skipLocationChange]="false" routerLink="/pages/reminder" (click)="closeReminderPopover()">
      <strong>{{'button.add-new' | translate}}</strong>
    </a>
  </div>
</ng-template>

<!-- Favori Menüler Popover Content -->
<ng-template #favoritesPopoverContent>
  <div class="favorites-popover">
    <div class="favorites-header">
      <h6 class="mb-0">
        <i class="fas fa-star text-warning me-2"></i>
        Favori Menüler
      </h6>
    </div>
    <div class="favorites-body">
      <div *ngIf="favoriteMenus.length === 0" class="no-favorites">
        <i class="fas fa-info-circle text-muted"></i>
        <p class="mb-0">Henüz favori menü eklenmemiş</p>
        <small class="text-muted">Menüleri favorilere eklemek için yanlarındaki yıldıza tıklayın</small>
      </div>
      <div *ngIf="favoriteMenus.length > 0" class="favorites-list">
        <div *ngFor="let menu of favoriteMenus" class="favorite-item" (click)="navigateToFavorite(menu)">
          <i class="fas {{ menu.icon || 'fa-link' }} favorite-item-icon"></i>
          <span class="favorite-text">{{ menu.translateKey | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-template>